<template>
    <v-card outlined v-bind="{ to }">
        <v-row>
            <v-col cols="12" md="5" class="mb-20 mb-md-0">
                <div class="pr-lg-40 w-100">
                    <v-img :aspect-ratio="1 / 1" :src="item?.thumb?.url" class="rounded-lg w-100">
                        <template #placeholder>
                            <v-overlay absolute z-index="0" opacity=".1"> <v-icon>mdi-image</v-icon> </v-overlay>
                        </template>
                    </v-img>
                </div>
            </v-col>
            <v-col cols="12" md="7">
                <div class="pl-lg-10">
                    <div class="rental__head pr-md-154 pr-lg-190">
                        <h3 class="tit line-height-12 mb-8 mb-md-0">{{ item?.name }}</h3>
                        <div class="rental__head-btn">
                            <v-btn v-if="!readonly" x-small elevation="0" rounded color="primary" class="mr-4 mr-lg-8 d-flex" :disabled="item.isRentDisabled">예약하기</v-btn>
                            <rental-subject-detail-dialog v-if="item?.detail" v-bind="{ item }">
                                <template #activator="{ attrs, on }">
                                    <v-btn x-small color="grey" rounded outlined v-bind="attrs" v-on="on" @click.prevent.stop.capture="on.click">
                                        <span class="grey-dark--text">상세보기</span>
                                    </v-btn>
                                </template>
                            </rental-subject-detail-dialog>
                        </div>
                    </div>
                    <v-divider class="my-12 my-lg-30"></v-divider>
                    <ul class="rental__info page-text grey-dark--text">
                        <li class="d-flex" v-for="{ text, value } of descriptions" :key="text">
                            <p class="min-w-80px mr-12">
                                <strong class="font-weight-bold">
                                    {{ text }}
                                </strong>
                            </p>
                            <p>
                                {{ value }}
                            </p>
                        </li>
                    </ul>
                </div>
            </v-col>
        </v-row>

        <!-- <div class="pa-30 pa-md-40 pa-lg-60">
            <v-row class="ma-0">
                <v-col cols="12" md="auto">
                    <v-img :width="$vuetify.breakpoint.xs ? '100%' : 350" :aspect-ratio="1 / 1" :src="item?.thumb?.url" class="rounded-lg ma-auto">
                        <template #placeholder>
                            <v-overlay absolute z-index="0" opacity=".1"> <v-icon>mdi-image</v-icon> </v-overlay>
                        </template>
                    </v-img>
                    <imgs-overlay-list class="pa-1 ma-n1" :items="imgs" :displaylength="4" />
                </v-col>
                <v-col>
                    <div class="ml-md-20 ml-lg-40 ml-xl-72">
                        <div class="tit-wrap mb-0">
                            <h2 class="tit">{{ item?.name }}</h2>
                        </div>
                        <div class="page-text">
                            <v-row v-for="{ text, value } of descriptions" :key="text" align="center" class="row--small mt-0">
                                <v-col cols="auto">
                                    <div class="w-lg-100px font-weight-bold grey-1e--text">{{ text }}</div>
                                </v-col>
                                <v-col cols="auto" class="d-flex align-center"><v-divider vertical class="h-10px" /></v-col>
                                <v-col class="white-space-pre-line">{{ value }}</v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
                <v-col cols="auto" class="d-flex flex-column">
                    <v-btn v-if="!readonly" elevation="0" rounded color="primary">예약하기</v-btn>
                    <rental-subject-detail-dialog v-if="item?.detail" v-bind="{ item }">
                        <template #activator="{ attrs, on }">
                            <v-btn class="mt-10" rounded outlined v-bind="attrs" v-on="on" @click.prevent.stop.capture="on.click">상세보기</v-btn>
                        </template>
                    </rental-subject-detail-dialog>
                </v-col>
            </v-row>
        </div> -->
    </v-card>
</template>

<script>
import { RENTAL_SUBJECT_TYPES } from "@/assets/variables";
import ImgsOverlayList from "../dumb/imgs-overlay-list.vue";
import RentalSubjectDetailDialog from "./rental-subject-detail-dialog.vue";
export default {
    components: {
        ImgsOverlayList,
        RentalSubjectDetailDialog,
    },
    props: {
        item: { type: Object, default: () => ({}) },
        readonly: { type: Boolean, default: false },
    },
    computed: {
        to() {
            if (this.readonly || this.item?.isRentDisabled) return;
            else return `/rental/${this.item?.type?.toLowerCase?.()}/${this.item?._id}`;
        },
        imgs() {
            return (this.item?.photos || []).map(({ url }) => url);
        },
        descriptions() {
            const items = [
                { text: "사용료", value: this.item?.isFree ? "무료" : this.item?.charge },
                { text: "장소", value: this.item?.location },
                { text: "담당자", value: this.item?.worker },
                { text: "연락처", value: this.item?.contact },
                { text: "용도", value: this.item?.usage },
            ];
            if (this.item?.type == RENTAL_SUBJECT_TYPES.EQUIPMENTS.value) {
                const equipmentItems = [
                    { text: "구축일자", value: this.item?.dateOfConstruction },
                    { text: "표준분류", value: this.item?.classificationName },
                    { text: "설치장소", value: this.item?.placeOfInstallment },
                    { text: "활용범위", value: this.item?.rangeOfApplication },
                ];
                items.push(...equipmentItems);
            }
            return items.filter(({ value }) => value);
        },
    },
};
</script>

<style lang="scss" scoped>
.white-space-pre-line {
    white-space: pre-line;
}
.rental__head {
    position: relative;
}
.rental__head-btn {
    display: flex;
    justify-content: flex-end;
}
.rental__info > li:not(:last-child) {
    margin-bottom: 4px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .rental__head-btn {
        position: absolute;
        top: 7px;
        right: 0;
    }
}
@media (min-width: 1024px) {
    .rental__head-btn {
        top: 4px;
    }
    .rental__info > li:not(:last-child) {
        margin-bottom: 10px;
    }
}
@media (min-width: 1200px) {
}
</style>